export enum ESTADO_SESSION_INFO  {
    LOGIN = 1,
    ACEPTAR_TERMINO = 2 ,
    NO_ACEPTO_TERMINO = 3 ,
    INICIAR_SIMULACION = 4,
    INICIAR_PRUEBA = 5,
    CONTINUAR_PRUEBA = 6, 
    FINALIZA_PRUEBA = 7,
    INICIO_PREGUNTA_ABIERTA = 8,
    CIERRE_PREGUNTA_ABIERTA = 9,
    APROBACION_JURAMENTO = 10,
}